import { Component } from '@angular/core';
import { UserGridItemObject } from '@it2go/types';
import { ReactiveFormsModule } from '@angular/forms';
import { fb } from '../../../../shared/shared.global-service';
import { BaseDialogComponent } from '../../../../../components/kit/base-dialog/base-dialog.component';
import { ActionButtonsComponent } from '../../../../../components/kit/action-buttons/action-buttons.component';
import { SelectInputComponent } from '../../../../../components/kit/input/select-input/select-input.component';
import { FormatPersonPipe } from '../../../../shared/pipes/format-person.pipe';

@Component({
    selector: 'app-person-contact-upsert-name-match-dialog',
    styleUrls: ['./person-contact-upsert-name-match-dialog.component.scss'],
    templateUrl: 'person-contact-upsert-name-match-dialog.component.html',
    imports: [
        ReactiveFormsModule,
        ActionButtonsComponent,
        SelectInputComponent,
        FormatPersonPipe,
    ]
})
export class PersonContactUpsertNameMatchDialogComponent extends BaseDialogComponent {

    protected users: UserGridItemObject[] = [];
    protected form = fb.group({
        user: fb.control<UserGridItemObject | null>(null),
    });

    constructor() {
        super();

        this.users = this.dialogConfig.data.users;
    }

    override save(_event: Event): void | Promise<void> {
        this.dialogRef.close({ user: this.form.value.user ?? null });
    }
}
